import React from 'react'
import { Button } from "semantic-ui-react";

export function MyButton(props) {
    return <Button type="button" basic {...props}/>
}